import { Validator } from '@vista-digital/validator';
import { BarcodeType } from '../../../../subcomponents';
import { barcodeTypeValidator } from '../../../../subcomponents/barcode/types/type';
export const memberBarcodeConfigValidator = Validator.object({
    type: barcodeTypeValidator
});
export const defaultMemberBarcodeConfig = {
    type: BarcodeType.QrCode
};
